export { default as LeftSideProfileCard } from "./left-side-profil-card";
export { default as LeftSideSubjectCard } from "./left-side-subject-card";
